import { render, staticRenderFns } from "./OrganisationContactList.vue?vue&type=template&id=5e70e7fe&"
import script from "./OrganisationContactList.vue?vue&type=script&lang=js&"
export * from "./OrganisationContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports